<ion-grid class="ai-configuration">

    <ion-row>

        <ion-col size="12" class="ion-no-padding">

            <ion-card class="ion-no-margin full">

                <ion-card-header>
                    <div class="header-title">
                        <ion-card-title i18n=":@@configurations_ai.title-configuration">Configuração de AI</ion-card-title>
                        <span class="updated" *ngIf="Data?.UpdateDate">
                            <ng-container i18n=":@@configurations_ai.last-update">Última alteração</ng-container>
                            <date-tooltip [date]="Data?.UpdateDate"></date-tooltip>
                        </span>
                    </div>

                    <ion-buttons>

                        <ng-container *ngIf="!IsEditing">
                            <ion-button fill="solid" color="medium" title="Editar" (click)="OnEdit($event)"
                                i18n-title=":@@configurations_ai.btn-edit" aria-label="Editar"
                                i18n-aria-label=":@@configurations_ai.btn-edit"
                                [actionsPermissions]="EnumActionsPermissions.CREATEANDEDIT">
                                <ion-icon slot="icon-only" name="create-outline"></ion-icon>
                            </ion-button>
                        </ng-container>

                        <ng-container *ngIf="IsEditing">
                            <ion-button fill="solid" color="medium" title="Cancelar" (click)="OnCancelEdit($event)"
                                i18n-title=":@@configurations_ai.btn-cancel" aria-label="Cancelar"
                                i18n-aria-label=":@@configurations_ai.btn-cancel"
                                [actionsPermissions]="EnumActionsPermissions.CREATEANDEDIT">
                                <ion-icon slot="icon-only" name="close-outline"></ion-icon>
                            </ion-button>

                            <ion-button fill="solid" color="primary" title="Guardar" (click)="OnSave($event)"
                                i18n-title=":@@configurations_ai.btn-save" aria-label="Guardar"
                                i18n-aria-label=":@@configurations_ai.btn-save"
                                [actionsPermissions]="EnumActionsPermissions.CREATEANDEDIT">
                                <ion-icon slot="icon-only" name="save-outline"></ion-icon>
                            </ion-button>
                        </ng-container>

                    </ion-buttons>

                </ion-card-header>

                <ion-card-content>

                    <form [formGroup]="Form">

                        <!-- estado: lê o valor do formulário, para mudar logo ao carregar no interruptor -->
                        <section class="status" [class.is-on]="IsActiveValue">

                            <div class="status-text">
                                <div class="status-line">
                                    <span class="status-name" i18n=":@@configurations_ai.status-name">Pesquisa AI</span>
                                    <span class="status-pill">
                                        <span class="dot" aria-hidden="true"></span>
                                        <ng-container *ngIf="IsActiveValue" i18n=":@@configurations_ai.active_2">Ativa</ng-container>
                                        <ng-container *ngIf="!IsActiveValue" i18n=":@@configurations_ai.disabled_2">Desativada</ng-container>
                                    </span>
                                </div>

                                <p *ngIf="IsActiveValue" i18n=":@@configurations_ai.status-on">As perguntas feitas na
                                    Pesquisa AI das Estatísticas são respondidas até se atingir o limite mensal.</p>
                                <p *ngIf="!IsActiveValue" i18n=":@@configurations_ai.status-off">As perguntas da Pesquisa
                                    AI não são enviadas e não há custos.</p>
                                <p *ngIf="!Data?.HasApiKey" class="status-warning"
                                    i18n=":@@configurations_ai.status-no-key">Ainda não há chave de API guardada. Sem ela
                                    não é possível ativar.</p>
                            </div>

                            <ion-toggle *ngIf="IsEditing" formControlName="IsActive" mode="ios"
                                aria-label="Ativar a Pesquisa AI"
                                i18n-aria-label=":@@configurations_ai.status-toggle"></ion-toggle>

                        </section>

                        <!-- gasto do mês corrente face ao limite guardado -->
                        <section class="budget" [ngClass]="'budget-' + (CostLimitVariant || 'none')">

                            <div class="budget-head">
                                <span class="budget-period">
                                    <ng-container i18n=":@@configurations_ai.budget-period">Gasto em</ng-container>
                                    {{ CurrentMonthLabel }}
                                </span>
                                <span class="budget-percent" *ngIf="CostLimit > 0">{{ CostLimitUsedPercent }}%</span>
                            </div>

                            <div class="budget-figure">
                                <span class="spent">{{ FormatCost(CurrentMonthCost) }}</span>
                                <span class="of" *ngIf="CostLimit > 0">
                                    <ng-container i18n=":@@configurations_ai.budget-of">de</ng-container>
                                    {{ FormatCost(CostLimit) }}
                                </span>
                                <span class="of" *ngIf="CostLimit <= 0"
                                    i18n=":@@configurations_ai.budget-no-limit">sem limite definido</span>
                            </div>

                            <div class="meter" *ngIf="CostLimit > 0" role="progressbar"
                                [attr.aria-valuenow]="CostLimitUsedPercent" aria-valuemin="0" aria-valuemax="100"
                                aria-label="Limite mensal utilizado"
                                i18n-aria-label=":@@configurations_ai.tile-limit-used">
                                <span class="fill" [style.width.%]="CostLimitUsedPercent"></span>
                                <span class="tick" title="75%" aria-hidden="true"></span>
                            </div>

                            <div class="budget-foot">
                                <span *ngIf="CostLimitVariant !== 'neg'">
                                    <ng-container i18n=":@@configurations_ai.budget-reset">O contador volta a zero a</ng-container>
                                    {{ ResetDateLabel }}
                                </span>
                                <span *ngIf="CostLimitVariant === 'neg'" class="limit-reached">
                                    <ng-container i18n=":@@configurations_ai.budget-reached">Limite atingido: a Pesquisa
                                        AI fica parada até</ng-container>
                                    {{ ResetDateLabel }}
                                </span>
                                <span class="requests">
                                    {{ Data?.CurrentMonthRequests || 0 }}
                                    <ng-container i18n=":@@configurations_ai.budget-requests">pedidos este mês</ng-container>
                                </span>
                            </div>

                        </section>

                        <ion-row class="fields">

                            <ion-col size="12" sizeMd="6">
                                <ion-item class="full" lines="full">
                                    <ion-label position="stacked" i18n=":@@configurations_ai.api-key" required>Chave de
                                        API
                                    </ion-label>
                                    <password-toggle>
                                        <ion-input type="password" formControlName="ApiKey" autocomplete="off"
                                            [placeholder]="Data?.HasApiKey ? (Data?.ApiKeyMask || '••••••••') : 'Introduza a chave de API'">
                                        </ion-input>
                                    </password-toggle>
                                </ion-item>
                                <ion-note *ngIf="Data?.HasApiKey" class="hint"
                                    i18n=":@@configurations_ai.api-key-hint-2">A chave completa nunca é mostrada. Deixe
                                    em branco para manter a atual, ou escreva outra para a substituir.</ion-note>
                            </ion-col>

                            <ion-col size="12" sizeMd="6">
                                <div class="limit-group">
                                    <ion-item class="currency" lines="full">
                                        <ion-label position="stacked" i18n=":@@configurations_ai.currency"
                                            required>Moeda
                                        </ion-label>
                                        <ion-select formControlName="IdCurrency" interface="popover"
                                            [disabled]="Form.get('IdCurrency').disabled">
                                            <ion-select-option [value]="EnumAICurrency.EUR">EUR (€)</ion-select-option>
                                            <ion-select-option [value]="EnumAICurrency.USD">USD ($)</ion-select-option>
                                        </ion-select>
                                    </ion-item>
                                    <ion-item class="amount" lines="full">
                                        <ion-label position="stacked" i18n=":@@configurations_ai.cost-limit"
                                            required>Limite de custo mensal
                                        </ion-label>
                                        <ion-input type="number" min="0" step="0.01" inputmode="decimal"
                                            formControlName="CostLimitMonth">
                                        </ion-input>
                                    </ion-item>
                                </div>
                                <ion-note class="hint" i18n=":@@configurations_ai.cost-limit-hint">Ao atingir o limite,
                                    os pedidos de AI deixam de ser executados até ao mês seguinte.</ion-note>
                            </ion-col>

                        </ion-row>

                        <ion-row class="fields" *ngIf="Data?.Models?.length > 0">

                            <ion-col size="12" sizeMd="6">
                                <ion-item class="full" lines="full">
                                    <ion-label position="stacked" i18n=":@@configurations_ai.model">Modelo</ion-label>
                                    <ion-select formControlName="Model" interface="popover"
                                        [placeholder]="ModelLabel(Data?.Model)">
                                        <ion-select-option *ngFor="let item of Data?.Models" [value]="item.Model">{{
                                            ModelLabel(item.Model) }}</ion-select-option>
                                    </ion-select>
                                </ion-item>
                                <ion-note class="hint" *ngIf="SelectedModelPrice">{{ SelectedModelPrice }}</ion-note>
                            </ion-col>

                        </ion-row>

                    </form>

                </ion-card-content>
            </ion-card>

        </ion-col>

    </ion-row>

    <ion-row>

        <ion-col size="12" class="ion-no-padding">

            <ion-card class="ion-no-margin ion-margin-top full">

                <ion-card-header>
                    <ion-card-title i18n=":@@configurations_ai.title-consumption">Consumo mensal</ion-card-title>

                    <ion-item class="year-select" lines="none">
                        <ion-select [value]="Year" interface="popover" (ionChange)="OnChangeYear($event)"
                            aria-label="Ano" i18n-aria-label=":@@configurations_ai.year-aria">
                            <ion-select-option *ngFor="let item of Years" [value]="item">{{ item }}
                            </ion-select-option>
                        </ion-select>
                    </ion-item>

                </ion-card-header>

                <ion-card-content>

                    <ion-row *ngIf="Consumption?.length > 0">
                        <ion-col size="12">
                            <div class="chart-box">
                                <bar-chart *ngIf="Chart" [data]="Chart" height="240"></bar-chart>
                            </div>
                        </ion-col>
                    </ion-row>

                    <ion-grid class="table ion-no-padding" *ngIf="Consumption?.length > 0">

                        <ion-row class="table-header">
                            <ion-col class="flex-align-center" i18n=":@@configurations_ai.table-month">Mês</ion-col>
                            <ion-col class="flex-align-center num" i18n=":@@configurations_ai.table-requests">Pedidos
                            </ion-col>
                            <ion-col class="flex-align-center num" i18n=":@@configurations_ai.table-tokens-in_2">Tokens
                                de entrada</ion-col>
                            <ion-col class="flex-align-center num" i18n=":@@configurations_ai.table-tokens-out_2">Tokens
                                de saída</ion-col>
                            <ion-col class="flex-align-center num" i18n=":@@configurations_ai.table-cost">Custo</ion-col>
                            <ion-col class="flex-align-center col-status-icon-2"
                                i18n=":@@configurations_ai.table-limit-reached">Limite</ion-col>
                        </ion-row>

                        <ion-row *ngFor="let item of Consumption" style="display: block;">
                            <ion-item class="ion-no-margin">

                                <ion-grid class="ion-no-margin ion-no-padding">

                                    <ion-row class="table-body">

                                        <ion-col class="flex-align-center">{{ MonthLabel(item) }}</ion-col>
                                        <ion-col class="flex-align-center num">{{ (item?.Requests || 0) | number }}</ion-col>
                                        <ion-col class="flex-align-center num">{{ (item?.InputTokens || 0) | number }}</ion-col>
                                        <ion-col class="flex-align-center num">{{ (item?.OutputTokens || 0) | number }}</ion-col>
                                        <ion-col class="flex-align-center num">{{ FormatCost(item?.Cost, item?.IdCurrency)
                                            }}</ion-col>
                                        <ion-col class="flex-align-center col-status-icon-2">
                                            <ion-badge *ngIf="item?.LimitReached" color="danger"
                                                i18n=":@@configurations_ai.limit-reached">Atingido</ion-badge>
                                        </ion-col>

                                    </ion-row>

                                </ion-grid>

                            </ion-item>
                        </ion-row>

                    </ion-grid>

                    <no-items *ngIf="!Consumption || Consumption?.length == 0"
                        description="Ainda não há pedidos de AI registados neste ano"
                        i18n-description=":@@configurations_ai.no-consumption-2"></no-items>

                </ion-card-content>
            </ion-card>

        </ion-col>

    </ion-row>

</ion-grid>
